import getHrefWithHostname from "./getHrefWithHostname";

const formatExternalLink = (link) => {
  return link?.href ? getHrefWithHostname(link.href) : link;
};

export default formatExternalLink;
